/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("giveupModule", []).
controller("giveupCtrl", ["$scope", '$modalInstance', 'trsHttpService', "$document","$timeout", function($scope, $modalInstance, trsHttpService, $document,$timeout) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            //suc:false,//成功弹层
        };
        $scope.data = {};
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {

    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [giveup description] 放弃编辑
     * @return {[type]} [description]
     */
    $scope.giveup = function() {
        $modalInstance.close(true);
    };

}]);